import { FirebaseEventName } from "./firebase-analytics";
import { IntercomEvent } from "./intercom";
import { Preferences } from "@capacitor/preferences";
import { getLegacyNativeHealthIntegration } from "./native";
import { Capacitor } from "@capacitor/core";
import { addServiceToIntegration } from "../actions-stencil-store/health";

export async function loadStoredState() {
  try {
    const { value } = await Preferences.get({ key: "sw:state" });
    if (value === null) {
      return undefined;
    }
    const statefromPreferences: SworkitPersistedState = JSON.parse(value);
    const statePlusNewDefaults = addNewDefaultState(statefromPreferences);
    return statePlusNewDefaults;
  } catch (err) {
    console.error("error loading stored state", err);
    return undefined;
  }
}

export function saveState(state: SworkitState) {
  try {
    const stateCopy = removeUnusedState(state);
    const serializedState = JSON.stringify(stateCopy);
    return setStorageKey("sw:state", serializedState);
  } catch (err) {
    console.error("error saving state", err);
    //ignore write errors
  }
}

export function setStorageKey(
  key: StorageKey | FirebaseEventName | IntercomEvent,
  value: string,
) {
  return Preferences.set({ key, value });
}

export function removeStorageKey(
  key: StorageKey | FirebaseEventName | IntercomEvent,
) {
  return Preferences.remove({ key });
}

export async function getStorageKey(
  key: StorageKey | FirebaseEventName | IntercomEvent,
) {
  const { value } = await Preferences.get({ key });
  return value;
}

export function clearState() {
  return Preferences.clear();
}

export function removeUnusedState(state: SworkitState) {
  const persistedState: SworkitPersistedState = {
    health: state.health,
    localSettings: state.localSettings,
    notifications: state.notifications,
    plans: state.plans,
    subscription: state.subscription,
    user: state.user,
  };
  return persistedState;
}

function addNewDefaultState(state: SworkitPersistedState) {
  const integration = getLegacyNativeHealthIntegration();
  if (state && state.localSettings && !state.localSettings.mySworkit) {
    state.localSettings.mySworkit = "calendar";
  }
  if (state && state.localSettings && !state.localSettings.musicVolume) {
    state.localSettings.musicVolume = 40;
  }
  if (state.health?.healthWriteEnabled && Capacitor.isNativePlatform()) {
    addServiceToIntegration("writeEnabledIntegrations", integration);
    state.health.healthWriteEnabled = false;
  }
  if (state.health?.healthReadEnabled && Capacitor.isNativePlatform()) {
    addServiceToIntegration("readEnabledIntegrations", integration);
    state.health.healthReadEnabled = false;
  }

  if (state.user?.userLoaded) {
    state.user.userLoaded = false;
  }
  return state;
}
